/** Сезон и лига. */
import { PosInt, UInt } from "../common";
import { z } from "zod";

/**
 * Сезон и обмен кристаллов (ISSUE-74, MADR 0010). Нет раздела в данных — сезона нет (старые снимки баланса).
 * Награды шага считает `seasonReward` engine: монеты от лучшей волны, остальное по кратности номера шага.
 */
export const SeasonDef = z.object({
  /** День (`streakDayIndex`), с которого идёт сезон 1. */
  epochDay: UInt,
  lengthDays: PosInt,
  steps: PosInt,
  pointsPerStep: PosInt,
  /** Больше этого за день очков не зачисляется. */
  dailyCap: PosInt,
  points: z.object({
    /** Очки за полностью убитую волну: не зависят от номера волны, поздний игрок не копит быстрее. */
    perClearedWave: PosInt,
    boss: UInt,
    /** За забранное задание дня и за мешок. */
    task: UInt,
  }),
  free: z.object({ coinWaves: PosInt, crystals: UInt, crystalsEvery: PosInt }),
  pass: z.object({
    coinWaves: PosInt,
    crystals: UInt,
    crystalsEvery: PosInt,
    /** Каждый такой шаг даёт снятие таймера. */
    skipEvery: PosInt,
    /** Каждый такой шаг даёт час x2. */
    speedEvery: PosInt,
  }),
  shop: z.object({
    skipCrystals: PosInt,
    speedCrystals: PosInt,
    speedHours: PosInt,
    bagCrystals: PosInt,
    /** Мешок монет: столько базовых наград за волну на лучшей волне. */
    bagWaves: PosInt,
    heroCrystals: PosInt,
    /** Героя можно открыть не раньше, чем за столько волн до его волны открытия. */
    heroWavesAhead: PosInt,
  }),
});
export type SeasonDef = z.infer<typeof SeasonDef>;

/** Лиги (ISSUE-75, MADR 0013). Нет раздела в данных — лиг нет (старые снимки баланса). */
export const LeagueDef = z.object({
  /** Больше этого людей в группе не садим. */
  groupSize: PosInt,
  /** Доля группы, что поднимается и опускается по итогу недели. */
  zonePermille: PosInt,
  rewards: z.object({
    /** Кристаллы за 1-е, 2-е, 3-е… место. */
    places: z.array(UInt).min(1),
    /** Кристаллы за подъём на ступень. */
    promoted: UInt,
    /** Множитель награды по ступеням, от нижней к верхней; длина задаёт число ступеней. */
    tierPermille: z.array(PosInt).min(2),
  }),
});
export type LeagueDef = z.infer<typeof LeagueDef>;
